"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCompletePasswordResetBody = void 0;
const validation_1 = require("@fmtk/validation");
const RegisterBody_1 = require("./RegisterBody");
exports.validateCompletePasswordResetBody = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
    newPassword: (0, validation_1.text)(undefined, RegisterBody_1.MinimumPasswordLength),
    secret: (0, validation_1.text)(),
});
//# sourceMappingURL=CompletePasswordResetBody.js.map